export default __webpack_public_path__ + "static/media/greenenergy.6ba0ce32.svg";